import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ParentAPIService} from "../parent.api.service";
import {Observable} from "rxjs";
import {CrystalclearClearingBackUrl} from "../config/crystalclear-clearing-back-url";
import {ClearingInfoLoadRequest} from "../../model/clearing/clearing-info-load-request";
import {ApiValidation} from "../../model/api/api-validation";
import {ClearingSelectionInfo} from "../../model/clearing/clearing-selection-info";
import {ClearingSelectionSummary} from "../../model/clearing/clearing-selection-summary";

@Injectable({
  providedIn: 'root'
})
export class ClearingOrderInfoService extends ParentAPIService implements OnInit, OnDestroy {


  constructor(http: HttpClient) {
    super(http);
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
  }

  public getSelectionSummary(request: ClearingInfoLoadRequest): Observable<ApiValidation<ClearingSelectionSummary[]>> {
    return this.post(CrystalclearClearingBackUrl.GET_CLEARING_ORDER_INFO_SELECTION_SUMMARY, request);
  }

  public getSelectionSummaryTradeMode(request: ClearingInfoLoadRequest): Observable<ApiValidation<ClearingSelectionSummary[]>> {
    return this.post(CrystalclearClearingBackUrl.GET_CLEARING_ORDER_INFO_SELECTION_SUMMARY_TRADE_MODE, request);
  }

  public getSelectionInfoLegs(request: ClearingInfoLoadRequest): Observable<ApiValidation<ClearingSelectionInfo[]>> {
    return this.post(CrystalclearClearingBackUrl.GET_CLEARING_ORDER_INFO_SELECTION_INFO_LEGS, request);
  }

  public getSelectionInfoLegsTradeMode(request: ClearingInfoLoadRequest): Observable<ApiValidation<ClearingSelectionInfo[]>> {
    return this.post(CrystalclearClearingBackUrl.GET_CLEARING_ORDER_INFO_SELECTION_INFO_LEGS_TRADE_MODE, request);
  }

}
